import type { LucideIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

export function EmptyState({
  icon: Icon,
  body,
  action,
}: {
  icon: LucideIcon;
  body: string;
  action?: { to: string; label: string };
}) {
  return (
    <div className="border-base-300 flex flex-col items-center gap-3 rounded-box border-2 border-dashed px-6 py-10 text-center">
      <span aria-hidden className="bg-primary/10 text-primary grid size-14 place-items-center rounded-full">
        <Icon className="size-7" />
      </span>
      <p className="text-base-content/70 max-w-sm">{body}</p>
      {action && (
        <Link to={action.to} className="btn btn-primary btn-sm min-h-(--hit-min)">
          {action.label}
        </Link>
      )}
    </div>
  );
}
